import { render, staticRenderFns } from "./TabTiket.vue?vue&type=template&id=d2cb3f44"
import script from "./TabTiket.vue?vue&type=script&lang=js"
export * from "./TabTiket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports